up.compiler('[cash-voucher]', (element) => {
  element.addEventListener('click', function() {
    let form = element.closest('form')
    up.validate(form, { target: '.voucher-cashing-list, .booking--total-price' })
  })
})
